import Product from '~/models/Product/Product'
import LuigisBoxItem from '~/models/LuigisBox/LuigisBoxItem'

export const transformProductsToLuigisBoxItems = (products: Product[]): LuigisBoxItem[] => {
    const config = useRuntimeConfig()
    const luigisBoxItems: LuigisBoxItem[] = []
    for (let i = 0; i < products.length; i++) {
        const product = products[i]
        luigisBoxItems.push({
            title: product.name,
            url: `${config.public.apiUrl}${product.url}`,
            position: i + 1,
            price: product.price,
            type: 'item',
        })
    }

    return luigisBoxItems
}
